import { ChatResponder } from "@redotech/redo-model/agents/chat-history";
import { Return } from "@redotech/redo-model/return";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoChat } from "@redotech/redo-web/arbiter-components/chat/redo-chat";
import StarsIcon from "@redotech/redo-web/arbiter-icon/stars-01_filled.svg";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { useAiChat } from "./use-ai-chat";
export const AiChat = memo(function AiChat({ return_ }: { return_: Return }) {
  const {
    showChat,
    setShowChat,
    chatHistory,
    isTyping,
    textValue,
    setTextValue,
    submit,
    suggestions,
  } = useAiChat({ returnId: return_._id });
  return (
    <Flex justify="flex-start" position="relative" w="full">
      {!showChat && (
        <RedoButton
          dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={{
            background: "linear-gradient(90deg,#6bbaf2, #4a90e2 )",
            border: "none",
            color: "white",
          }}
          IconLeading={StarsIcon}
          onClick={() => setShowChat(true)}
          text="AI Chat"
        />
      )}
      {showChat && (
        <RedoChat
          chatHistory={chatHistory.map((chat) => ({
            key: chat.createdAt.toString(),
            text: chat.message,
            isResponder: chat.responder === ChatResponder.AI,
          }))}
          chatResponderName="Redo"
          close={function (): void {
            void setShowChat(false);
          }}
          fullWidth
          LeadingIcon={StarsIcon}
          responderTyping={isTyping}
          setTextValue={setTextValue}
          submit={submit}
          suggestions={suggestions}
          textValue={textValue}
          title="AI return chat"
        />
      )}
    </Flex>
  );
});
